import { createAction, props } from '@ngrx/store';
import { VaultRoleActions } from '../../models/vault/role-actions.model';

export const setRoleActions = createAction(
  '[Role Actions] Set Role Actions',
  props<{ roleActions: VaultRoleActions }>()
);
